import { Injectable } from '@angular/core';
import { RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ApiService } from '../api.service';

const PACKAGES: any[] = [{
  id: 1,
  name: 'Consumer Properties',
  completeness: 0.95,
  type: 'static'
}, {
  id: 2,
  name: 'Grid Information',
  completeness: 0.65,
  type: 'static'
}, {
  id: 3,
  name: 'Electricity Consumption',
  completeness: 0.35,
  type: 'temporal',
  monthlyRecords: [{
    completeness: 0,
    records: 6000,
    date: 'Dec/2015'
  }, {
    completeness: 0.6,
    records: 6000,
    date: 'Jan/2016'
  }, {
    completeness: 0.55,
    records: 5000,
    date: 'Feb/2016'
  }, {
    completeness: 0.5,
    records: 5000,
    date: 'Mar/2016'
  }, {
    completeness: 0.5,
    records: 5000,
    date: 'Apr/2016'
  }, {
    completeness: 0.7,
    records: 7000,
    date: 'May/2016'
  }, {
    completeness: 0.6,
    records: 6000,
    date: 'Jun/2016'
  }, {
    completeness: 0.5,
    records: 5000,
    date: 'Jul/2016'
  }, {
    completeness: 0.6,
    records: 6000,
    date: 'Aug/2016'
  }, {
    completeness: 0.7,
    records: 7000,
    date: 'Sep/2016'
  }, {
    completeness: 0.8,
    records: 8000,
    date: 'Oct/2016'
  }, {
    completeness: 0.8,
    records: 8000,
    date: 'Nov/2016'
  }, {
    completeness: 0.9,
    records: 9000,
    date: 'Dec/2016'
  }, {
    completeness: 0.6,
    records: 6000,
    date: 'Jan/2017'
  }, {
    completeness: 0.4,
    records: 4000,
    date: 'Feb/2017'
  }, {
    completeness: 0.5,
    records: 5000,
    date: 'Mar/2017'
  }, {
    completeness: 0.4,
    records: 4000,
    date: 'Apr/2017'
  }, {
    completeness: 0.5,
    records: 5000,
    date: 'May/2017'
  }, {
    completeness: 0.45,
    records: 5000,
    date: 'Jun/2017'
  }, {
    completeness: 0.35,
    records: 5000,
    date: 'Jul/2017'
  }]
}, {
  id: 4,
  name: 'Electricity Occurrences',
  completeness: 0.15,
  type: 'temporal',
  monthlyRecords: [{
    completeness: 0,
    records: 6000,
    date: 'Dec/2015'
  }, {
    completeness: 0.1,
    records: 6000,
    date: 'Jan/2016'
  }, {
    completeness: 0.15,
    records: 5000,
    date: 'Feb/2016'
  }, {
    completeness: 0.2,
    records: 5000,
    date: 'Mar/2016'
  }, {
    completeness: 0.2,
    records: 5000,
    date: 'Apr/2016'
  }, {
    completeness: 0.25,
    records: 7000,
    date: 'May/2016'
  }, {
    completeness: 0.3,
    records: 6000,
    date: 'Jun/2016'
  }, {
    completeness: 0.5,
    records: 5000,
    date: 'Jul/2016'
  }, {
    completeness: 0.6,
    records: 6000,
    date: 'Aug/2016'
  }, {
    completeness: 0.7,
    records: 7000,
    date: 'Sep/2016'
  }, {
    completeness: 0.8,
    records: 8000,
    date: 'Oct/2016'
  }, {
    completeness: 0.8,
    records: 8000,
    date: 'Nov/2016'
  }, {
    completeness: 0.9,
    records: 9000,
    date: 'Dec/2016'
  }, {
    completeness: 0.6,
    records: 6000,
    date: 'Jan/2017'
  }, {
    completeness: 0.4,
    records: 4000,
    date: 'Feb/2017'
  }, {
    completeness: 0.5,
    records: 5000,
    date: 'Mar/2017'
  }, {
    completeness: 0.4,
    records: 4000,
    date: 'Apr/2017'
  }, {
    completeness: 0.3,
    records: 5000,
    date: 'May/2017'
  }, {
    completeness: 0.2,
    records: 5000,
    date: 'Jun/2017'
  }, {
    completeness: 0.15,
    records: 5000,
    date: 'Jul/2017'
  }]
}, {
  id: 5,
  name: 'Water Consumption',
  completeness: 0.55,
  type: 'temporal',
  monthlyRecords: [{
    completeness: 0,
    records: 6000,
    date: 'Dec/2015'
  }, {
    completeness: 0.4,
    records: 6000,
    date: 'Jan/2016'
  }, {
    completeness: 0.35,
    records: 5000,
    date: 'Feb/2016'
  }, {
    completeness: 0.5,
    records: 5000,
    date: 'Mar/2016'
  }, {
    completeness: 0.6,
    records: 5000,
    date: 'Apr/2016'
  }, {
    completeness: 0.45,
    records: 7000,
    date: 'May/2016'
  }, {
    completeness: 0.5,
    records: 6000,
    date: 'Jun/2016'
  }, {
    completeness: 0.5,
    records: 5000,
    date: 'Jul/2016'
  }, {
    completeness: 0.6,
    records: 6000,
    date: 'Aug/2016'
  }, {
    completeness: 0.7,
    records: 7000,
    date: 'Sep/2016'
  }, {
    completeness: 0.8,
    records: 8000,
    date: 'Oct/2016'
  }, {
    completeness: 0.8,
    records: 8000,
    date: 'Nov/2016'
  }, {
    completeness: 0.9,
    records: 9000,
    date: 'Dec/2016'
  }, {
    completeness: 0.6,
    records: 6000,
    date: 'Jan/2017'
  }, {
    completeness: 0.4,
    records: 4000,
    date: 'Feb/2017'
  }, {
    completeness: 0.5,
    records: 5000,
    date: 'Mar/2017'
  }, {
    completeness: 0.4,
    records: 4000,
    date: 'Apr/2017'
  }, {
    completeness: 0.5,
    records: 5000,
    date: 'May/2017'
  }, {
    completeness: 0.6,
    records: 5000,
    date: 'Jun/2017'
  }, {
    completeness: 0.55,
    records: 5000,
    date: 'Jul/2017'
  }]
}, {
  id: 6,
  name: 'Water Occurrences',
  completeness: 0.85,
  type: 'temporal',
  monthlyRecords: [{
    completeness: 0.6,
    records: 6000,
    date: 'Dec/2015'
  }, {
    completeness: 0.8,
    records: 6000,
    date: 'Jan/2016'
  }, {
    completeness: 0.75,
    records: 5000,
    date: 'Feb/2016'
  }, {
    completeness: 0.8,
    records: 5000,
    date: 'Mar/2016'
  }, {
    completeness: 0.85,
    records: 5000,
    date: 'Apr/2016'
  }, {
    completeness: 0.95,
    records: 7000,
    date: 'May/2016'
  }, {
    completeness: 0.7,
    records: 6000,
    date: 'Jun/2016'
  }, {
    completeness: 0.8,
    records: 5000,
    date: 'Jul/2016'
  }, {
    completeness: 0.6,
    records: 6000,
    date: 'Aug/2016'
  }, {
    completeness: 0.7,
    records: 7000,
    date: 'Sep/2016'
  }, {
    completeness: 0.8,
    records: 8000,
    date: 'Oct/2016'
  }, {
    completeness: 0.8,
    records: 8000,
    date: 'Nov/2016'
  }, {
    completeness: 0.9,
    records: 9000,
    date: 'Dec/2016'
  }, {
    completeness: 0.9,
    records: 6000,
    date: 'Jan/2017'
  }, {
    completeness: 0.8,
    records: 4000,
    date: 'Feb/2017'
  }, {
    completeness: 0.8,
    records: 5000,
    date: 'Mar/2017'
  }, {
    completeness: 0.7,
    records: 4000,
    date: 'Apr/2017'
  }, {
    completeness: 0.8,
    records: 5000,
    date: 'May/2017'
  }, {
    completeness: 0.9,
    records: 5000,
    date: 'Jun/2017'
  }, {
    completeness: 0.95,
    records: 5000,
    date: 'Jul/2017'
  }]
}];

const CHECKS = [{
  id: 1,
  type: 'failure',
  description: '500 CPs without coordinates'
}, {
  id: 2,
  type: 'failure',
  description: '350 CPs at coordinate 0 x 0'
}, {
  id: 3,
  type: 'failure',
  description: '250 CPs grouped at two coordinates'
}, {
  id: 4,
  type: 'failure',
  description: '300 CPs missing class information'
}, {
  id: 5,
  type: 'pass',
  description: 'All CPs with Class data'
}, {
  id: 6,
  type: 'warning',
  description: '50 CPs missing name (inside the tolerance range)'
}];

const UC = {
  latitude: 6.9103184703,
  longitude: -75.0734342253,
  blocked: true,
  risk: 0.5,
  quantityToRecover: 345,
  quantityToIncrease: 223,
  lastConsumption: 1600,
  lastVisit: 'Never',
  region: 'Region 1',
  municipality: 'Municipality 2',
  locality: 'Locality 2',
  neighborhood: 'Neighborhood 3',
  consumptionClass: 'COMMERCIAL',
  status: 'CUT'
};

@Injectable()
export class DataQualityService {
    private options: any;

    constructor(
        private apiService: ApiService
    ) {
      const headers = new Headers({ 'Content-Type': 'application/json' });
      this.options = new RequestOptions({ headers: headers });
      this.apiService.init();
    }

    getPackages(): Observable<any[]> {
      return Observable.of(PACKAGES);
    }

    getPackageById(id: number): Observable<any> {
      return Observable.of({
        ...PACKAGES.find(value => value.id === id),
        cpNumber: 15000,
        dataFailures: 1000,
        checks: CHECKS
      });
    }

    getCheckById(id: number): Observable<any> {
      return Observable.of({
        ...CHECKS.find(value => value.id === id),
        logs: [{
          ucId: 435433,
          name: 'Joao',
          description: 'Coordinate is null',
          ...UC
        }, {
          ucId: 765432,
          name: 'Maria',
          description: 'Coordinate is null',
          ...UC
        }, {
          ucId: 236845,
          name: 'Jose',
          description: 'Coordinate is null',
          ...UC
        }, {
          ucId: 445653,
          name: 'Joao',
          description: 'Coordinate is null',
          ...UC
        }, {
          ucId: 342221,
          name: 'Maria',
          description: 'Coordinate is null',
          ...UC
        }, {
          ucId: 988799,
          name: 'Jose',
          description: 'Coordinate is null',
          ...UC
        }]
      });
    }

}



// WEBPACK FOOTER //
// ./src/app/core/api/data-quality.service.ts